import React, { Component } from 'react';
import { Provider } from 'react-redux';//, connect
import { HashRouter as Router, Route, Switch } from 'react-router-dom';//, Link
import store from './store';
import './styles/less/bootstrap.css';
import { PrivateRoute } from './authentication/PrivateRoute';

import { AnonLayout } from './anon/AnonLayout';
import { AuthLayout } from './auth/AuthLayout';
import AlertStack from './components/Alerts';

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <div>
                        <Switch>
                            <Route exact={true} path="/" component={AnonLayout} />
                            <Route exact={true} path="/Login" component={AnonLayout} />
                            <Route exact={true} path="/ForgotPassword" component={AnonLayout} />
                            <Route exact={true} path="/ResetPassword/:user" component={AnonLayout} />

                            <PrivateRoute exact={true} path="/Projects" component={AuthLayout} />
                            <PrivateRoute exact={true} path="/NewProject" component={AuthLayout} />                                

                            <PrivateRoute path="/:client/:project" component={AuthLayout} />
                        </Switch>
                        <AlertStack className="fix-bottom-right mr-sm mb-lg" />
                    </div>
                </Router>
            </Provider>
        );
    }
}

export default App;
